// extracted by mini-css-extract-plugin
export var cell = "_5n-4";
export var headerCell = "_5n-2";
export var rowHeader = "_5n-3";
export var table = "_5n-1";
export var tableContainer = "_5n-0";